import {
  STORE_FinaleSelelctCartMerchantNZone,
  STORE_CartCheckoutData,
  STORE_Addons,
  STORE_Cart,
} from "../../../../database/store-names";
import {
  FORMAT_DECIMAL_VALUE,
  CONCAT_TEXT_LIMIT,
  HEADER_TAB_SETUP,
} from "../../../../functions/funtion";
import {
  SET_STORE_CART_SELECT_MERCHATS_ZONE,
  SET_STORE_CART,
} from "../../../../database/store-data";
import { api_OpenSalesOrderForCustomerMobileApp } from "../../../../connection/api/api-orders";
import { dto_StartupPageLoadInfo } from "../../../../classes/dto-mobile-settings";
import { CSP, ENCRYPT_STORAGE } from "../../../../config/config";
import { PT_COMPLETEORDERS } from "../../../../routes/stack/paths/pt-profile";
import { set_dto_Merchant } from "../../../../classes/dto-setters/dto-setter";
import { F_Fammily, Font } from "../../../../util/config-fonts";
import { InvoiceTemplate } from "../print-invoice/invoice-template";
import { dto_common } from "../../../../classes/dto-common";
import { PT_ORDERS } from "../../../../routes/stack/paths/pt-orders";
import { PT_CART } from "../../../../routes/stack/paths/pt-cart";
import { Colors } from "../../../../util/colors";
import Alert from "../../../../components/Alert";
import React from "react";
import "../../../../styles/css/pg-profile-menulist.css";
import "../../../../styles/css/pg-order-invoice.css";
import "../../../../styles/css/pg-cart-itemList.css";
import { ToastMessage } from "../../../../components/toast-notification/toast";

export default class ViewInvoice extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      POSID: this.props.params.orderID,
      items: [],
      MerchantURL: "",
      Merchant: "",
      GrandTotal: 0,
      SubTotal: 0,
      TotalTax: 0,
      DeliveryCharges: 0,
      TotalServiceCharge: 0,
      DisplayDiscount: 0,
      GUNO: "",
      DeliveryDate: "",
      DeliveryAddress: "",
      DeliveryDateAndTime: "",
      MerchantInfo: [],
      isLoaded: true,
      DeliveryTimeSlot: "",
    };
  }

  async componentDidMount() {
    const { params, navigate } = this.props;
    const frmPage = params.frmPage;
    const commonHeaderSetup = {
      HeaderTabName: CONCAT_TEXT_LIMIT({
        length: 20,
        string: "Order Detail",
      }),
      FnGoBackScreen: () =>
        navigate(frmPage === "completed" ? PT_COMPLETEORDERS : PT_ORDERS),
      HeaderNavigatorMenuDisplay: true,
      HeaderNavigatorMenuFaBoostrapIconName: "bi bi-printer",
      FnHeaderNavigatorMenu: () => this.PrintInvoice(),
    };
    if (CSP === "AV") {
      if (frmPage === "order") {
        commonHeaderSetup.HeaderNavigatorMenuDisplay = false;
      } else {
        commonHeaderSetup.HeaderNavigatorMenuDisplay = false;
      }
    } else {
      commonHeaderSetup.HeaderNavigatorMenuDisplay = false;
    }

    await this.SalesInvoicePOSSelect();
    await HEADER_TAB_SETUP(commonHeaderSetup);
  }

  async ReOrderItem() {
    if (this.state.MerchantInfo.isOpen === false) {
      // Alert.MessageBox({
      //   Tittle: "Info",
      //   Text: "Closed for order for this outlet",
      // });

      await ToastMessage(1, "Closed for order for this outlet");

      return;
    } else {
      Alert.ConfirmationMessageBox({
        Tittle: "Confirmation",
        Text: "Do you want to Re-generate from this order?",
        CancelButtonMessage: "No",
        ConfirmButtonText: "Yes",
        ConfirmButtonFunction: async () => {
          let ProductInfo = [];
          let data = this.state.items;
          for (let i = 0; i < data.length; i++) {
            if (data[i].PID !== 1224929 && data[i].TID !== 5) {
              let prdDetail = {
                LineID: data[i].LineID,
                PID: data[i].PID,
                TID: data[i].TID,
                Code: data[i].Code,
                ProductImageUrl: data[i].ProductImageUrl,
                Desc: data[i].Desc,
                USeqID: data[i].USeqID,
                UOM: data[i].UOM,
                UP: data[i].UP,
                UD: data[i].UD,
                ServiceCharge: data[i].ServiceCharge,
                Qty: parseInt(data[i].Qty),
                DecPoint: data[i].DecPoint,
                Total: data[i].Total,
                Modification: data[i].Modification,
                ExtraCost: data[i].ExtraCost,
                DocDiscount: 0,
                VAT: data[i].VAT,
                TAXID: data[i].TAXID,
                TaxEquation: data[i].TaxEquation,
                MID: data[i].MID,
                GDescription: data[i].GenDesc,
                IsAvailable: data[i].IsAvailable,
                ADDONLINEID: data[i].LineID,
                UDPer: 0,
                IsRecommended: 0,
              };
              ProductInfo.push(prdDetail);
            }
          }
          if (ProductInfo.length > 0) {
            await ENCRYPT_STORAGE.removeMultipleItems([
              STORE_Cart,
              STORE_Addons,
              STORE_FinaleSelelctCartMerchantNZone,
              STORE_CartCheckoutData,
            ]);
            await SET_STORE_CART(ProductInfo);
            const updatedMerchantInfo = [...this.state.MerchantInfo];
            updatedMerchantInfo[0] = { ...updatedMerchantInfo[0], CATID: 0 };
            this.setState({
              MerchantInfo: updatedMerchantInfo,
            });
            await set_dto_Merchant(this.state.MerchantInfo[0]);
            await SET_STORE_CART_SELECT_MERCHATS_ZONE(
              this.state.MerchantInfo[0],
            );
            this.props.navigate(PT_CART);
          }
        },
      });
    }
  }

  async SalesInvoicePOSSelect() {
    this.setState({ isLoaded: true });
    let data = await api_OpenSalesOrderForCustomerMobileApp(this.state.POSID);
    let objdata = JSON.parse(data);
    let objobjdata = JSON.parse(objdata);
    let ObjSalesOrderHeader = objobjdata[1][0];

    this.setState(
      {
        items: objobjdata[0],
        MerchantURL: ObjSalesOrderHeader.ImageURL,
        Merchant: ObjSalesOrderHeader.Merchant,
        GrandTotal: ObjSalesOrderHeader.GrandTotal,
        SubTotal: ObjSalesOrderHeader.SubTotal,
        TotalTax: ObjSalesOrderHeader.TotalTax,
        DeliveryCharges: ObjSalesOrderHeader.DeliveryCharges,
        TotalServiceCharge: ObjSalesOrderHeader.TotalServiceCharge,
        DisplayDiscount: ObjSalesOrderHeader.DisplayDiscount,
        GUNO: "#" + ObjSalesOrderHeader.GUNO,
        DeliveryDate: ObjSalesOrderHeader.DeliveryDate,
        DeliveryAddress: ObjSalesOrderHeader.DeliveryAddress,
        DeliveryDateAndTime: ObjSalesOrderHeader.DeliveryDateAndTime,
        MerchantInfo: JSON.parse(objobjdata[2].MerchantInfo),
        DeliveryTimeSlot: ObjSalesOrderHeader.DeliveryTimeSlot,
      },
      () => {
        this.setState({ isLoaded: false });
      },
    );
  }

  PrintInvoice = () => {
    // if (isMobile) {
    const message = {
      type: "GENERATE_PDF",
      html: this.Bill(),
      name: this.invoiceNoShow(),
    };
    window.ReactNativeWebView.postMessage(JSON.stringify(message));
    // } else {
    //   const content = this.Bill();
    //   html2pdf(content, {
    //     margin: 10,
    //     filename: this.invoiceNoShow(),
    //     image: { type: 'jpeg', quality: 0.98 },
    //     html2canvas: { scale: 2 },
    //     jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' },
    //   });
  };

  Bill() {
    return InvoiceTemplate(
      this.state.GUNO,
      this.state.DeliveryDate,
      this.state.items,
      this.state.SubTotal,
      this.state.DisplayDiscount,
      this.state.TotalServiceCharge,
      this.state.DeliveryCharges,
      this.state.TotalTax,
      this.state.GrandTotal,
    );
  }

  invoiceNoShow() {
    let x = this.state.GUNO + "invoice.pdf";
    x = x.substring(1);
    return x;
  }

  render() {
    return (
      <>
        {this.state.isLoaded ? (
          <div
            className="loader"
            style={{ marginTop: "90%", marginLeft: "45%" }}
          />
        ) : (
          <div className="pgOrderInvoiceLayout fadeInUp animated">
            <div className="pgOrderInvoiceImg">
              <img
                src={this.state.MerchantURL}
                alt=""
                onError={(e) => {
                  e.currentTarget.src = dto_common.DefaultImageUrl;
                }}
              />

              <div className="pgOrderInvoiceLabel">{this.state.Merchant}</div>
            </div>
            <div
              className="pgOrderInvoiceCard"
              style={{
                display: "flex",
              }}
            >
              <div>
                <label style={{ fontWeight: "bold" }}>Order No:</label>
                <label style={{ display: "flex", justifyContent: "flex-end" }}>
                  {this.state.GUNO}
                </label>
              </div>

              <div>
                {this.props.params.frmPage === "order" ? (
                  <>
                    <label style={{ fontWeight: "bold" }}>Order Date:</label>
                    <label
                      style={{ display: "flex", justifyContent: "flex-end" }}
                    >
                      {this.state.DeliveryDate}
                    </label>
                  </>
                ) : (
                  <div>
                    <button
                      style={{
                        color: "white",
                        border: 0,
                        background: "none",
                        fontFamily: F_Fammily.Medium,
                        fontSize: "18px",
                        backgroundColor: Colors.DarkGreyScale,
                        cursor: "pointer",
                        padding: 6,
                        borderRadius: "8px",
                      }}
                      onClick={() => {
                        this.ReOrderItem();
                      }}
                    >
                      Re-Order
                    </button>
                  </div>
                )}
              </div>
            </div>
            <hr />
            <div className="pgCartAdd" style={{ cursor: "pointer" }}>
              <div className="pgCartAddWrap">
                <i
                  className="bi bi-geo-alt-fill"
                  aria-hidden="true"
                  style={{ fontSize: "24px" }}
                />
                <p style={{ textAlign: "left" }}>
                  {this.state.DeliveryAddress}
                </p>
              </div>
            </div>
            <hr />
            {this.state.DeliveryDateAndTime !== "" ? (
              <div
                className="pgOrderInvoiceTimeSlot"
                style={{ display: "flex", flexDirection: "column" }}
              >
                {this.state.DeliveryTimeSlot !== "" ? (
                  <>
                    <label>Date: {this.state.DeliveryDate}</label>
                    <label style={{ marginTop: "5px" }}>
                      Time: {this.state.DeliveryTimeSlot}
                    </label>
                  </>
                ) : (
                  <label>
                    {CSP === "DT" || CSP === "MK" ? (
                      <i
                        className="bi bi-calendar-date-fill"
                        aria-hidden="true"
                        style={{
                          marginLeft: "4px",
                          fontSize: "24px",
                          marginRight: "18px",
                        }}
                      />
                    ) : (
                      "Date:"
                    )}{" "}
                    {this.state.DeliveryDateAndTime}
                  </label>
                )}
              </div>
            ) : (
              ""
            )}
            {CSP === "DT" || CSP === "MK" ? (
              <>
                <hr />
                <div className="pgCartAdd" style={{ cursor: "pointer" }}>
                  <div className="pgCartAddWrap">
                    <i
                      className="bi bi-card-heading"
                      aria-hidden="true"
                      style={{ fontSize: "24px" }}
                    />
                    <p style={{ textAlign: "left" }}>{this.state.GUNO}</p>
                  </div>
                </div>
              </>
            ) : null}

            <hr />
            <div className="itemListLayout">
              {this.state.items.map((rs, i) => {
                if (rs.ProductImageUrl === "") {
                  rs.ProductImageUrl = dto_common.DefaultImageUrl;
                } else if (rs.ProductImageUrl === "N/A") {
                  rs.ProductImageUrl = dto_common.DefaultImageUrl;
                }
                var DESCRIPTION = "";
                if (rs.Desc.includes("μ")) {
                  DESCRIPTION = rs.Desc.substring(rs.Desc.lastIndexOf("μ"), 0);
                } else {
                  DESCRIPTION = rs.Desc;
                }
                var descriptionWarning = rs.Desc.split("μ");
                var note = rs.Modification.substring(
                  rs.Modification.lastIndexOf("µµ"),
                  0,
                );
                var editednote = note.split("|");
                var notedesc = "";
                editednote.forEach((notess, i) => {
                  notedesc +=
                    "," + notess.substring(0, notess.lastIndexOf("¥"));
                });
                if (rs.TID !== 5) {
                  return (
                    <div
                      className="itemListLayout fadeInUp animated"
                      data-wow-duration="300ms"
                      data-wow-delay="0ms"
                      key={rs.PID + "ViewInvoice" + rs.LineID}
                    >
                      <div
                        className="itemListRow"
                        style={{ gridTemplateColumns: "auto 50px 80px" }}
                      >
                        <div
                          className="itemListRowText"
                          style={{ cursor: "pointer" }}
                        >
                          <p
                            style={{
                              margin: 0,
                              fontFamily: F_Fammily.Medium,
                              fontSize: "13px",
                            }}
                          >
                            {DESCRIPTION}
                          </p>
                          {notedesc.length > 1 ? (
                            <p
                              style={{
                                fontSize: Font.Description,
                                fontStyle: "italic",
                                margin: 0,
                              }}
                            >
                              {notedesc.substring(1)}
                            </p>
                          ) : null}
                          {descriptionWarning[1] !== undefined ? (
                            <p
                              style={{
                                color: "orange",
                                fontSize: Font.Description,
                                margin: 0,
                              }}
                            >
                              {descriptionWarning[1]}
                            </p>
                          ) : null}

                          {(CSP === "AV" && rs.PID === 1224929) ||
                          CSP === "DT" ||
                          CSP === "MK" ? (
                            ""
                          ) : (
                            <p
                              style={{
                                color: rs.IsAvailable ? "green" : "red",
                                fontSize: Font.Description,
                                margin: 0,
                              }}
                            >
                              {rs.IsAvailable ? "Available" : "Not Available"}
                            </p>
                          )}

                          {rs.UD > 0 ? (
                            <div style={{ display: "flex" }}>
                              <p
                                style={{
                                  paddingTop: 0,
                                  marginTop: "4px",
                                  marginBottom: "4px",
                                  fontSize: Font.Amount,
                                  color: "red",
                                  alignSelf: "stretch",
                                  textDecorationLine: "line-through",
                                  textDecorationStyle: "solid",
                                  marginRight: 5,
                                }}
                              >
                                {dto_StartupPageLoadInfo.Currency}
                                {"  "}
                                {FORMAT_DECIMAL_VALUE(
                                  2,
                                  parseFloat(rs.UP) * parseFloat(rs.Qty) +
                                    parseFloat(rs.ExtraCost),
                                  2,
                                )}
                              </p>
                              <p
                                style={{
                                  paddingTop: 0,
                                  color:
                                    CSP === "DT" || CSP === "MK"
                                      ? "black"
                                      : Colors.ThemeBGcolor,
                                  marginTop: "4px",
                                  marginBottom: "4px",
                                  fontSize: Font.Amount,
                                }}
                              >
                                {dto_StartupPageLoadInfo.Currency}
                                {"  "}
                                {FORMAT_DECIMAL_VALUE(
                                  2,
                                  (parseFloat(rs.UP) - parseFloat(rs.UD)) *
                                    parseFloat(rs.Qty),
                                  2,
                                )}
                              </p>
                            </div>
                          ) : (
                            <p
                              style={{
                                fontSize: Font.Amount,
                                margin: 0,
                                color:
                                  CSP === "DT" || CSP === "MK"
                                    ? "black"
                                    : Colors.ThemeBGcolor,
                              }}
                            >
                              {dto_StartupPageLoadInfo.Currency}{" "}
                              {(
                                parseFloat(rs.UP) * parseFloat(rs.Qty) +
                                parseFloat(rs.ExtraCost)
                              )
                                .toFixed(2)
                                .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")}
                            </p>
                          )}

                          {(CSP === "DT" || CSP === "MK") &&
                          rs.PID !== 1224929 ? (
                            <p
                              style={{
                                color: rs.IsAvailable ? "green" : "red",
                                fontSize: Font.Description,
                                margin: 0,
                              }}
                            >
                              {rs.IsAvailable ? "Available" : "Not Available"}
                            </p>
                          ) : null}
                        </div>
                        <div
                          className="itemListRowText"
                          style={{ cursor: "pointer" }}
                        >
                          <img
                            src={rs.ProductImageUrl}
                            onError={(e) => {
                              e.currentTarget.src = dto_common.DefaultImageUrl;
                            }}
                            alt=""
                          />
                        </div>
                        <div
                          className="itemListRowText"
                          style={{ cursor: "pointer" }}
                        >
                          <p style={{ textAlign: "center" }}>
                            {" "}
                            {parseInt(rs.Qty)}
                          </p>
                        </div>
                      </div>
                    </div>
                  );
                } else {
                  return null;
                }
              })}
            </div>
            <br />
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                padding: 5,
                backgroundColor: "rgb(243, 243, 243)",
              }}
              className="fadeInUp animated"
              data-wow-duration="300ms"
              data-wow-delay="0ms"
            >
              <div className="pgCartPrice">
                <p
                  style={{
                    fontFamily: F_Fammily.Medium,
                    fontSize: "13px",
                  }}
                >
                  Sub Total
                </p>
                <p
                  style={{
                    display:
                      this.state.DisplayDiscount === 0 ? "none" : "block",
                    fontFamily: F_Fammily.Medium,
                    fontSize: "13px",
                  }}
                >
                  Discount
                </p>
                <p
                  style={{
                    display:
                      this.state.TotalServiceCharge === 0 ? "none" : "block",
                    fontFamily: F_Fammily.Medium,
                    fontSize: "13px",
                  }}
                >
                  Service
                </p>
                <p
                  style={{
                    display:
                      this.state.DeliveryCharges === 0 ? "none" : "block",
                    fontFamily: F_Fammily.Medium,
                    fontSize: "13px",
                  }}
                >
                  Delivery
                </p>
                <p
                  style={{
                    display: this.state.TotalTax === 0 ? "none" : "block",
                    fontFamily: F_Fammily.Medium,
                    fontSize: "13px",
                  }}
                >
                  Tax
                </p>
                <p
                  style={{
                    fontFamily: F_Fammily.Medium,
                    fontSize: "15px",
                  }}
                >
                  <strong>Total</strong>
                </p>
              </div>
              <div className="pgCartPrice">
                <p
                  style={{
                    textAlign: "right",
                    display: "grid",
                    gridTemplateColumns: "40px 60px",
                    fontFamily: F_Fammily.Medium,
                    fontSize: "13px",
                  }}
                >
                  <label className="CurrencyTxt">
                    {" "}
                    {dto_StartupPageLoadInfo.Currency}{" "}
                  </label>
                  <label>
                    {FORMAT_DECIMAL_VALUE(2, this.state.SubTotal, 2)}
                  </label>
                </p>
                <p
                  style={{
                    display: this.state.DisplayDiscount === 0 ? "none" : "grid",
                    textAlign: "right",
                    gridTemplateColumns: "40px 60px",
                    fontFamily: F_Fammily.Medium,
                    fontSize: "13px",
                  }}
                >
                  <label className="CurrencyTxt">
                    {" "}
                    {dto_StartupPageLoadInfo.Currency}{" "}
                  </label>
                  <label>
                    {FORMAT_DECIMAL_VALUE(2, this.state.DisplayDiscount, 2)}
                  </label>
                </p>
                <p
                  style={{
                    display:
                      this.state.TotalServiceCharge === 0 ? "none" : "grid",
                    textAlign: "right",
                    gridTemplateColumns: "40px 60px",
                    fontFamily: F_Fammily.Medium,
                    fontSize: "13px",
                  }}
                >
                  <label className="CurrencyTxt">
                    {" "}
                    {dto_StartupPageLoadInfo.Currency}{" "}
                  </label>
                  <label>
                    {FORMAT_DECIMAL_VALUE(2, this.state.TotalServiceCharge, 2)}
                  </label>
                </p>

                <p
                  style={{
                    display: this.state.DeliveryCharges === 0 ? "none" : "grid",
                    textAlign: "right",
                    gridTemplateColumns: "40px 60px",
                    fontFamily: F_Fammily.Medium,
                    fontSize: "13px",
                  }}
                >
                  <label className="CurrencyTxt">
                    {" "}
                    {dto_StartupPageLoadInfo.Currency}{" "}
                  </label>
                  <label>
                    {FORMAT_DECIMAL_VALUE(2, this.state.DeliveryCharges, 2)}
                  </label>
                </p>

                <p
                  style={{
                    display: this.state.TotalTax === 0 ? "none" : "grid",
                    textAlign: "right",
                    gridTemplateColumns: "40px 60px",
                    fontFamily: F_Fammily.Medium,
                    fontSize: "13px",
                  }}
                >
                  <label className="CurrencyTxt">
                    {" "}
                    {dto_StartupPageLoadInfo.Currency}{" "}
                  </label>
                  <label>
                    {" "}
                    {FORMAT_DECIMAL_VALUE(2, this.state.TotalTax, 2)}{" "}
                  </label>
                </p>

                <p
                  style={{
                    textAlign: "right",
                    fontWeight: "bold",
                    display: "grid",
                    gridTemplateColumns: "40px 60px",
                    fontFamily: F_Fammily.Medium,
                    fontSize: "15px",
                  }}
                >
                  <label className="CurrencyTxt">
                    {" "}
                    {dto_StartupPageLoadInfo.Currency}{" "}
                  </label>
                  <label>
                    {" "}
                    {FORMAT_DECIMAL_VALUE(2, this.state.GrandTotal, 2)}
                  </label>
                </p>
              </div>
            </div>
          </div>
        )}
      </>
    );
  }
}
